export default __webpack_public_path__ + "static/media/3-colocada.de22657a.png";